

export enum EventName {
    ACCEPT_LOAN_OFFER = "Accept loan offer",
    SIGN_LOAN_AGREEMENT = "Sign loan agreement",
    E_NACH = "E NACH",
    SCAN_AND_UPLOAD_NACH = "Scan & Upload NACH",
}

export const updateConsentEvent = (eventName: string, isSuccess: boolean) => {
};
